import { Box, Grid } from "@mui/material";

import FeedResults from "./FeedResults";
import FeedResultsMobile from "./FeedResultsMobile";
import ModalTrigger from "../Common/ModalTrigger";
import CustomLink from "../Common/CustomLink";

const Glyphosate = (props) => {
  return (
    <Grid
      flexWrap="nowrap"
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{
        marginTop: { xs: "50px", sm: "50px", md: "90px" },
      }}
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="#F8F8F8"
    >
      <Grid
        item
        xs
        p={3}
        className="four-one"
        sx={{
          maxWidth: { md: "450px !Important" },
          textAlign: { xs: "left", sm: "center", md: "left" },
        }}
      >
        <Box>
          <h3>Focus on glyphosate</h3>
          <p className="paragraph">
            Glyphosate is {" "}
            <CustomLink
              href="https://eur-lex.europa.eu/eli/reg_impl/2023/2660/oj"
              text="approved for use in the EU"
            />{" "}
            until 15 December 2033. In relation to the 2023 data in this report, glyphosate could be used as an active substance in Plant Protection Products (PPPs), subject to each PPP being authorised by national authorities following an evaluation of its safety. In this section, all data received on glyphosate or on its metabolites/degradation products is presented.{" "}
            {/* <CustomLink
							href='https://eur-lex.europa.eu/eli/reg_impl/2023/2660/oj'
							text='peer review'
						/>
						, which is due to be completed in July 2023. */}
          </p>
          <p className="paragraph">
           In 2023, 26 countries analysed glyphosate residues in 15,591 samples of food commodities. Additionally, residues were also identified in 674 feed samples and 18 fish samples.
          </p>
          <p className="paragraph">
            In 97.9% of the food samples, glyphosate was not quantified. In 1.9% (296) of samples, glyphosate was quantified at levels above the LOQ but below the MRL, and in 0.2% (39) of samples the residue levels exceeded the MRL. When measurement uncertainty was taken into account, 0.1% (23) of samples were reported as non-compliant mainly in dried beans (4 samples from Argentina), honey and other apicultural products (4 samples from Lithuania) and buckwheat and other pseudo–cereals (2 samples from Poland). In all 399 baby food samples, glyphosate residues were not quantified.
          </p>
          <p className="paragraph">
            The following glyphosate{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="metabolites"
            />{" "}
           were quantified in food: aminomethylphosphonic acid (AMPA) (0.2%, mainly in soyabeans). AMPA-N-acetyl and N-acetyl glyphosate were not quantified.
          </p>
          <p className="paragraph">
            Trimethyl-sulfonium cation resulting from the use of glyphosate was analysed by 8 MSs and was quantified in 44 samples (0.7%), mainly in cultivated fungi, citrus fruits and teas. {" "}
          </p>
          <p className="paragraph">
            {" "}
            In feed where MRLs are not set, glyphosate related substances were quantified as follows: glyphosate (27%), AMPA (20%) and AMPA-N-acetyl (54%).
          </p>
        </Box>
      </Grid>
      <Grid
        item
        xs
        className="four-two"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          p={3}
          sx={{
            display: { xs: "none", sm: "none", md: "block" },
          }}
        >
          <FeedResults />
        </Box>
        <Box
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            width: "100%",
            maxHeight: "600px",
            maxWidth: "300px",
          }}
          display="flex"
          flexDirection="column"
          alignItems="start"
          justifyContent="flex-start"
        >
          <FeedResultsMobile />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Glyphosate;
